import { CaretRightIcon } from '@phosphor-icons/react';

import type { SkillItem } from '@pages/PracticePage/model';
import { cn } from '@shared/lib/utils';
import { getScoreColor } from '../lib/getScoreColor';

export const SkillItemRow = ({
  item,
  showDescriptions,
  onOpen,
}: {
  item: SkillItem;
  showDescriptions: boolean;
  onOpen: () => void;
}) => {
  return (
    <button
      className="flex w-full cursor-pointer items-center justify-between rounded-xl border border-border/60 bg-card px-4 py-3 text-left transition-colors hover:bg-accent/30"
      type="button"
      onClick={onOpen}
    >
      <div className="pr-4 flex flex-col gap-2">
        <div className="text-[16px] font-medium text-foreground">{item.title}</div>
        {showDescriptions ? (
          <div className="text-sm text-muted-foreground">{item.description}</div>
        ) : null}
      </div>
      <div className="flex items-center gap-2">
        <span className={cn('text-xl font-medium', getScoreColor(item.score))}>{item.score}%</span>
        <CaretRightIcon className="h-4 w-4 text-muted-foreground" />
      </div>
    </button>
  );
};
